export default {
  name: 'BaseQueryInput',

  computed: {
    query () {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (name !== 'BaseQuery') {
        parent = parent.$parent
        if (!parent) break
        name = parent.$options.name
      }
      return parent
    }
  },

  mounted () {
    this.query && this.query.$emit('addField', this)
  },

  beforeDestroy () {
    this.query && this.query.$emit('removeField', this)
  },

  data () {
    return {
      focused: false
    }
  },

  methods: {
    resetField () {
      this.$emit('input', '')
    }
  },

  directives: {
    'selection-on-focus' (el, binding) {
      const children = Array.from(el.children)
      const input = children.find(node => node && node.nodeName.toLowerCase() === 'input')
      if (input && binding.value && binding.value !== binding.oldValue) {
        input.selectionStart = 0
        input.selectionEnd = String(input.value).length
      }
    }
  },

  render (h) {
    const { placeholder = '搜索关键词', clearable = true, ...attrs } = this.$attrs
    const props = {
      attrs,
      on: this.$listeners,
      directives: [
        {
          name: 'selection-on-focus',
          value: this.focused
        }
      ]
    }
    return <el-input
      type="text"
      placeholder={placeholder}
      prefix-icon="el-icon-search"
      clearable={clearable}
      onFocus={() => (this.focused = true)}
      onBlur={() => (this.focused = false)}
      vOn:keypress_native_enter={() => this.query && this.query.confirm()}
      { ...props }
    />
  }
}
